import Withdraw from './withdraw-progressive';

export default Withdraw;
